export default __webpack_public_path__ + "static/car-loans-image-ef5e053cfd972dfd83b2e3cd8ce559be.webp";